var activeLinkWatcher = {
  options: {
    "watchers": []
  },

  selectors: {
    "panel_to_watch": ".js-active-link-watcher",
  },

  init: function () {
    const self = this;

    const jquery_panel_to_watch = jQuery(self.selectors.panel_to_watch);

    if (jquery_panel_to_watch.length === 0) {
      return;
    }

    jquery_panel_to_watch.find("a").each(function () {
      self.createWatcher(jQuery(this).attr("href"));
    });

    let frame = 0;
    jQuery(window).on("scroll", function () {
      frame++;
      if (frame < 5) return; //process only every 5th frame for more js performance
      frame = 0;

      const scroll_top = jQuery(this).scrollTop();
      self.setActiveItem(jquery_panel_to_watch, scroll_top);
    })
  },

  createWatcher: function (element_id) {
    const self = this;

    self.options.watchers.push([element_id, jQuery(element_id).offset().top]);
  },

  setActiveItem: function (jquery_panel_to_watch, scroll_top) {
    const self = this;

    jquery_panel_to_watch.find("a").removeClass("active");

    const filtered = self.options.watchers.filter(item => item[1] > scroll_top);
    if (filtered.length > 0) {
      jquery_panel_to_watch.find("a[href='" + filtered[0][0] + "']").addClass("active");
    }
  },
}

// Export
export { activeLinkWatcher };